import './App.css';

// components import
import { DataProvider} from './Context/dataContext';
import { FetchProvider} from './Context/fetchContext';
// import StudentLogin from './Pages/StudentLogin';
// import ParentLogin from './Pages/ParentLogin';
import EducatorLogin from './Pages/EducatorLogin';
import { CreateNewPwrd } from './Pages/NewPassword';

// external libraries import
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
// import { ConfirmOtp } from './Pages/ConfirmOtp';

function App() {
  return (
    <Router basename={'/login'}>
      <FetchProvider>
        <DataProvider>
          <AnimatePresence exitBeforeEnter>
            <Switch>
              <Route exact path = '/'>
                <EducatorLogin />
              </Route>
              {/* <Route path = '/forgot-password'>
                <ForgotPswrdModal />
              </Route> */}
              <Route path = '/create-new-password'>
                <CreateNewPwrd />
              </Route>
              {/* <Route path = '/confirm-OTP'>
                <ConfirmOtp />
              </Route> */}
              {/* <Route path = '/students'>
                <StudentLogin />
              </Route> */}
              {/* <Route path = '/parents'>
                <ParentLogin />
              </Route> */}
            </Switch>

          </AnimatePresence>
        </DataProvider>
      </FetchProvider>
    </Router>
  );
}

export default App;
